import styled from 'styled-components/macro';
import { DisplayFieldHorizontal } from '../DisplayFieldHorizontal';
import { translations } from '../../../../../locales/translations';
import { Grid } from '@mui/material';
import { commonStyle } from '../../../../../styles/theme/themes';
import React, { useState } from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';

export function HistoryTable(props) {
  const { data } = props;
  const [historyRecords, setHistoryRecords] = useState<any[]>([]);

  const reformatDataToString = (data) => {
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(data)) {
      return new Date(data).toLocaleString();
    } else if (typeof data === 'string' || typeof data === 'number') {
      return data;
    }
    return JSON.stringify(data);
  };

  React.useEffect(() => {
    setHistoryRecords([]);
    if (data.biChange) {
      findChild(data.biChange);
    }
    if (data.worklistStatusChange) {
      Object.keys(data.worklistStatusChange).forEach(fieldKey => {
        if (fieldKey.includes('statusReasons')) {
          return;
        }
        handleJsonDiffString(fieldKey, data['worklistStatusChange'][fieldKey]);
      });
    }
  }, [data]);

  const findChild = (parent) => {
    Object.keys(parent).forEach(childKey => {
      if (typeof parent[childKey] === 'object' && (!JSON.stringify(parent[childKey]['__new']))) {
        return findChild(parent[childKey]);
      } else if (['~', ' '].includes(parent[childKey])) {
        return;
      } else if (['+', '-'].includes(parent[childKey])) {
        handleJsonNewString(parent);
        return;
      } else {
        handleJsonDiffString(childKey, parent[childKey]);
        return;
      }
    });
  };

  const handleJsonDiffString = (fieldKey, fieldData) => {
    if (fieldKey.includes('__added')) {
      setHistoryRecords(historyRecords => [...historyRecords, {
        fieldKey: fieldKey.split('__')[0],
        old: '',
        new: reformatDataToString(fieldData),
      }]);
    } else if (fieldKey.includes('__deleted')) {
      setHistoryRecords(historyRecords => [...historyRecords, {
        fieldKey: fieldKey.split('__')[0],
        old: reformatDataToString(fieldData),
        new: '',
      }]);
    } else if (fieldData['__old'] || fieldData['__new']) {
      setHistoryRecords(historyRecords => [...historyRecords, {
        fieldKey: fieldKey,
        old: reformatDataToString(fieldData['__old']),
        new: reformatDataToString(fieldData['__new']),
      }]);
    }
  };

  const handleJsonNewString = (newJson) => {
    if (newJson[0] === '+') {
      Object.keys(newJson[1]).forEach(fieldKey => {
        if (typeof newJson[1][fieldKey] === 'object') {
          const tempChild = ['+', newJson[1][fieldKey]];
          findChild(tempChild);
        } else {
          setHistoryRecords(historyRecords => [...historyRecords, {
            fieldKey: fieldKey,
            old: '',
            new: reformatDataToString(newJson[1][fieldKey]),
          }]);
        }
      });
    } else if (newJson[0] === '-') {
      Object.keys(newJson[1]).forEach(fieldKey => {
        if (typeof newJson[1][fieldKey] === 'object') {
          const tempChild = ['-', newJson[1][fieldKey]];
          findChild(tempChild);
        } else {
          setHistoryRecords(historyRecords => [...historyRecords, {
            fieldKey: fieldKey,
            old: reformatDataToString(newJson[1][fieldKey]),
            new: '',
          }]);
        }
      });
    }
  };

  return (
    <Wrapper>
      <div className={`history-card`}>
        <Grid className='row'>
          <Grid item xs={12} md={12} lg={4}>
            <DisplayFieldHorizontal
              label={translations.ackSection}
              value={data.action}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            <DisplayFieldHorizontal
              label={translations.ackBy}
              value={data.user}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            <DisplayFieldHorizontal
              label={translations.ackDate}
              value={new Date(data.createdAt).toLocaleString()}
            />
          </Grid>
        </Grid>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} size='small'>
            <TableHead>
              <TableRow>
                <TableCell align='center' className='table-header'>
                  Edited field
                </TableCell>
                <TableCell align='center' className='table-header'>
                  Old value
                </TableCell>
                <TableCell align='center' className='table-header'>
                  New value
                </TableCell>
              </TableRow>
            </TableHead>
            {historyRecords.length > 0 && (
              <TableBody>
                {historyRecords.map((record, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align='center'>{record.fieldKey}</TableCell>
                    <TableCell align='center'>{record.old}</TableCell>
                    <TableCell align='center'>{record.new}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .history-card {
    margin: 10px;
    border-radius: 5px;
    box-shadow: ${commonStyle.boxShadow};
    border: 1px solid ${p => p.theme.border};
  }

  .history-details {
    margin-top: 10px;
    width: 100%;
  }

  .table-header {
    background: ${p => p.theme.primary};
    color: ${p => p.theme.background};
    opacity: 85%;
  }

  .row {
    padding: 5px 0;
    display: flex;
    width: 100%;
  }

  .MuiTableCell-root {
    min-width: 100px;
    padding: 5px;
  }
`;
